const contactUs = {
  portugues: {
    title: 'Fale Conosco',
    subTitle: 'Escolha uma opçao para suporte.',
    bellaQuestion: 'Quer ser uma Bella?',
    labelBellaQuastion: `
        Por favor, envie suas fotos para o e-mail <strong style="color:black">contato@belladasemana.com.br</strong>.<br> As fotos não precisam ser profissionais.
        <br>
        <br>
        Juntamente com as fotos, envie também uma breve apresentação contendo sua idade, a cidade onde mora, um telefone para contato, se já atua como modelo e se fez trabalhos conhecidos ou já posou para algum site ou revista, citando quais.
        <br>
        <br>
        Caso o perfil seja aprovado, a equipe de seleção do Bella da Semana entrará em contato através de e-mail ou telefone.
        <br>
        <br>
        Boa sorte e obrigada pela participação!
        `,
    inviteModel: 'Indicar uma modelo',
    labelInviteModel: `
        Para indicar uma modelo, solicitamos que peça à interessada que nos envie fotos para o e-mail <strong style="color:black">contato@belladasemana.com.br</strong>.<br> 
        <br>
        As fotos não precisam ser profissionais.        
        Solicitamos também uma breve apresentação contendo idade, a cidade onde mora, um telefone para contato, se já atua como modelo e se fez trabalhos conhecidos ou já posou para algum site ou revista, citando quais.
        <br>
        <br>
        Caso o perfil seja aprovado, a equipe de seleção do Bella da Semana entrará em contato através de e-mail ou telefone.
        <br>
        <br>
        Boa sorte e obrigada pela participação!
        
        `,
    labelFaq: [
      'Como renovar sua assinatura',
      'Checar o status de sua conta',
      'Não consegue acessar fotos e/ou vídeos?',
      'Críticas ou sugestões',
      'Entrar em contato'
    ],
    suggestionTitle: 'Para enviar suas críticas ou sugestões, preencha o formulário abaixo com seus dados, obrigado!',
    suggestionName: 'Nome',
    suggestionMail: 'E-mail',
    suggestionSubject: 'Assunto',
    suggestionMessage: 'Mensagem',
    suggestionButton: 'Enviar',    
    contactTitle: 'Preencha o formulário abaixo para entrar em contato conosco.',
    contactName: 'Nome',
    contactMail: 'E-mail',
    contactPhone: 'Telefone',
    contactCategory: 'Categoria',
    contactLogin: 'Login',
    contactSubject: 'Assunto',
    contactMessage: 'Mensagem',
    contactButton: 'Enviar',    
    fillRecaptcha: 'Preencha o recaptcha!',
    failSend: 'Falha ao enviar formulário!',
    msgClose: 'Fechar',
    msgTitle1: 'Erro',
    msgTitle2: 'Aviso',
    msgSuccess: 'Sua mensagem foi enviada e será respondida em até um dia útil. ATENÇÃO! Nesse período, por-favor, verifique a sua caixa de spam para garantir que nossa resposta não foi direcionada para a mesma. Obrigado pelo seu contato.',
    category0: 'Selecione uma categoria',
    category1: 'Cancelamentos',
    category2: 'Comentários / Sugestões',
    category3: 'Como assinar',
    category4: 'Contato Modelos',
    category5: 'Outros',
    category6: 'Problemas de acesso à conta'
  },
  ingles: {
    title: 'Contact Us',
    subTitle: 'Choose an option for support.',
    bellaQuestion: 'Do you want to be a Bella?',
    labelBellaQuastion: `
          Please send your photos to contato@belladasemana.com.br. Photos don't have to be professional.
          Along with the photos, also send a brief presentation containing your age, the city where you live, a contact number, if you already work as a model and if you have done well-known work or have posed for a website or magazine, mentioning which ones.

          If the profile is approved, the Bella Club selection team will contact you via email or telephone.
          Good luck and thanks for participating!
          `,
    inviteModel: 'Indicate a model',
    labelInviteModel: `
          To indicate a model, we ask that you ask the interested party to send us photos to the email contato@belladasemana.com.br. Photos don't have to be professional. We also request a brief presentation containing your age, the city where you live, a contact telephone number, whether you already work as a model and whether you have done well-known work or posed for a website or magazine, mentioning which ones.

          If the profile is approved, the Bella Club selection team will contact you via email or telephone.
        
          Good luck and thanks for participating!
        
          `,
    labelFaq: [
      'How to renew your subscription',
      'Check your account status',
      "Can't access photos and/or videos?",
      'Criticisms or suggestions',
      'Get in touch'
    ],
    suggestionTitle: 'To send your criticisms or suggestions, fill out the form below with your details, thank you!',
    suggestionName: 'Name',
    suggestionMail: 'Email',
    suggestionSubject: 'Subject',
    suggestionMessage: 'Message',
    suggestionButton: 'Send',    
    contactTitle: 'Fill out the form below to contact us.',
    contactName: 'Name',
    contactMail: 'Mail',
    contactCategory: 'Category',
    contactLogin: 'Login',
    contactSubject: 'Subject',
    contactMessage: 'Message',
    contactButton: 'Send',    
    fillRecaptcha: 'Fill out the recaptcha!',
    failSend: 'Failed to submit form!',
    msgClose: 'Close',
    msgTitle1: 'Error',
    msgTitle2: 'Notice',
    msgSuccess: 'Your message has been sent and we will get back to you in 24-working hours max. ATTENTION! During this period, please verify your spam and check if your replay hasn´t been redirect to it. Thank you for your contact.',
    category0: 'Select a category',         
    category1: 'Cancellations',
    category2: 'Comments / Suggestions',
    category3: 'How to subscribe',
    category4: 'Contact Models',
    category5: 'Others',
    category6: 'Account access problems'
  }
}

export default contactUs
